import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class RolesTableComponent extends Component {
  @service intl;

  @tracked columns = this.args?.columns ?? [
    {
      name: this.intl.t('roles.name'),
      valuePath: 'name',
      class: '!w-[80%] text-left',
      key: 'name',
      component: 'link',
      test_id: 'role-name',
      isSortable: false,
      cellClass: '!justify-start',
    },
    {
      name: this.intl.t('roles.capacity-fte'),
      valuePath: 'ftes',
      class: '!w-[10%] header-center',
      key: 'ftes',
      test_id: 'role-ftes',
    },
    {
      name: this.intl.t('roles.person', {
        num: 3,
      }),
      valuePath: 'people',
      class: '!w-[10%] header-center',
      key: 'people',
      component: 'link',
      isSortable: false,
      test_id: '',
    },
  ];

  convertRoleItemToRow(item) {
    return {
      name: {
        label: item.name,
        route: 'settings.roles.role.edit',
        model: item,
      },
      people: {
        label: item.activePeople.length,
        route: 'resources.people.active',
        query: { breakout: 'role' },
      },
      ftes: (+(item.ftes ?? 0)).toFixed(2),
    };
  }

  get rows() {
    if (this.args?.rows) return this.args?.rows;
    return this.args?.roles.map((item) => this.convertRoleItemToRow(item));
  }
}
